import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Initialize theme before React renders to prevent flash of wrong theme
(function initTheme() {
  const stored = localStorage.getItem('theme') || 'dark';
  let effective = stored;
  if (stored === 'system') {
    effective = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }
  document.documentElement.classList.remove('theme-light', 'theme-dark');
  document.documentElement.classList.add(effective === 'dark' ? 'theme-dark' : 'theme-light');
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
